import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=6972b456&scoped=true&"
import script from "./SearchForm.vue?vue&type=script&lang=ts&"
export * from "./SearchForm.vue?vue&type=script&lang=ts&"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=6972b456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972b456",
  null
  
)

export default component.exports